import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { TableStateService } from '../../services/table-state.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
})
export class LogoutComponent implements OnInit {
    constructor(
        private authService: LoginService,
        private router: Router,
        private tableStateService: TableStateService
    ) {}

    ngOnInit(): void {
        // Clear all filters before logout
        this.clearAllFilters();
        
        this.authService.logout();
        this.router.navigate(['/login'], {}).then(() => {
            // Clear table state history before clearing all localStorage
            localStorage.removeItem('tableStateHistory');
            localStorage.clear();
            window.location.reload();
        });
    }

    /**
     * Clear all filters from localStorage and sessionStorage
     */
    private clearAllFilters(): void {
        // Clear table state history and table states
        localStorage.removeItem('tableStateHistory');
        this.tableStateService?.clearAllStates();
        
        // Clear filter-related localStorage items
        localStorage.removeItem('filter');
        localStorage.removeItem('tabs');
        localStorage.removeItem('tabHistory');
        
        // Clear filter-related sessionStorage items
        sessionStorage.removeItem('productFilters');
        sessionStorage.removeItem('redirectNav');
        
        // Clear all table_state_* keys from sessionStorage (if any remain)
        try {
            const keysToRemove: string[] = [];
            for (let i = 0; i < sessionStorage.length; i++) {
                const key = sessionStorage.key(i);
                if (key && key.startsWith('table_state_')) {
                    keysToRemove.push(key);
                }
            }
            keysToRemove.forEach((key) => sessionStorage.removeItem(key));
        } catch (error) {
            console.error('Error clearing table state keys from sessionStorage:', error);
        }
    }
}
